import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import CryptoJS from 'crypto-js'

Vue.config.lKey = '52b1fcc2-b0ec-467a-8434-89ac4550fa42'
Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    isLogged: false,
    isInternalStaff: false,
    currentRole: 'User',
    passwordChangeRequired: false
  },
  mutations: {
    LOGIN_USER(state) {
      state.isLogged = true
    },

    LOGOUT_USER(state) {
      state.isLogged = false
      state.passwordChangeRequired = false
    },

    ROLE_SETUP(state, x) {
      state.currentRole = x;
    },

    PASSWORD_CHANGE_REQUIRED(state, x) {
      state.passwordChangeRequired = x;
    },
  },
  plugins: [createPersistedState({
    key: 'rKey',
      storage: {
        getItem: (key) => {
          try {
            var ciphertext = (window && window.localStorage).getItem(key);
            var bytes = CryptoJS.AES.decrypt(ciphertext.toString(), Vue.config.lKey);
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);

            if (plaintext !== undefined) {
              return JSON.parse(plaintext);
            }
          } catch (err) {
          }
          return undefined;
        },
        setItem: (key, value) => {
          try {
            var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(value), Vue.config.lKey);
            (window && window.localStorage).setItem(key, ciphertext);

          } catch (err) {
          }
        },
        removeItem: (key) => {
          try {

            (window && window.localStorage).setItem(key, undefined);
          } catch (err) {
          }
          return undefined;
        },
      }
    })
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js